import { create } from 'zustand';

interface ScreenShareSelectionStore {
  selectedSource: string | null;
  setSelectedSource: (sourceId: string | null) => void;
  clearSelectedSource: () => void;
}

export const useScreenShareSelectionStore = create<ScreenShareSelectionStore>((set) => ({
  selectedSource: null,
  setSelectedSource: (sourceId) => set({ selectedSource: sourceId }),
  clearSelectedSource: () => set({ selectedSource: null }),
}));
